<script>
  // DOCS: https://github.com/apertureless/vue-chartjs
  import { Bar, mixins } from 'vue-chartjs'

  export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options'],
      mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/BarChart.vue